export default {
  init() {
    // JavaScript to be fired on the career inner page

    // Custom input[type="file"]
    $('.wpcf7-form .file-input').click(function() {
      $('.wpcf7-form .wpcf7-file').click();
    });

    $('.wpcf7-form .wpcf7-file').change(function(){
      try{
        var filename = $(this)[0].files.item(0).name;
        if (filename !== undefined) $(".wpcf7-form .attached-file").text(filename);
      }catch(err){
        $(".wpcf7-form .attached-file").text("Attach Resume");
      }
    });

    // Disable button on submit
    $(".wpcf7-form").submit(function(){
      $(".wpcf7-form [type='submit']").prop("disabled", true);
    });

    $(".wpcf7-form").ajaxComplete(function(){
      $(".wpcf7-form [type='submit']").prop("disabled", false);
    });

    $(".wpcf7-form").ajaxError(function(){
      $(".wpcf7-form [type='submit']").prop("disabled", false);
    });

    $(".wpcf7-form").ajaxStop(function () {
      $(".wpcf7-form [type='submit']").prop("disabled", false);
    });

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/single-careers.js